import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B11PaymentTypeManagementPage } from '../b11-payment-type-management/b11-payment-type-management';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { MyApp } from '../../app/app.component';

/**
 * Generated class for the B11aPaymentTypeAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
	selector: 'page-b11a-payment-type-add',
	templateUrl: 'b11a-payment-type-add.html',
})
export class B11aPaymentTypeAddPage {
	
	private todo : FormGroup;
	loading: any;
	Status: any;
	public errorMessage: any = "";
	
	paymentTypeData = { TYPE:'', AUTHORIZE:'NO', PAYMENT_TYPE_ACTIVE:'YES'}

	constructor(public navCtrl: NavController, public navParams: NavParams,
				private formBuilder: FormBuilder, public serviceapi: ServiceApiProvider,
				public loadingCtrl: LoadingController) {
		
		this.todo = this.formBuilder.group({
			type: ['', Validators.required],
			authorize: ['', Validators.required],
			active: ['', Validators.required],
		});
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad B11aPaymentTypeAddPage');
	}
	
	save() {
		this.showLoader();
		this.serviceapi.insertdata("PAYMENT_TYPE",this.paymentTypeData).then((result) => {
			this.Status = result["Message"];
			//console.log(this.Status);
			if (this.Status == "1") {
				this.loading.dismiss();
				this.navCtrl.setRoot(B11PaymentTypeManagementPage);
			}
			else {
				this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
				this.loading.dismiss();
			}
		}, (err) => {
			this.errorMessage = "Loading Error. Please try again.";
			this.loading.dismiss();
		});
	}

	goToPaymentType() {
		this.navCtrl.pop();
	}

	goTo() {
		this.navCtrl.setRoot(B11PaymentTypeManagementPage);
	}

	showLoader() {
		this.loading = this.loadingCtrl.create({
			content: 'Loading...',
			//dismissOnPageChange: true,
		});
		this.loading.present();
	}
}



// WEBPACK FOOTER //
// ./src/pages/b11a-payment-type-add/b11a-payment-type-add.ts